"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Discount extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'discount';
        this._currency = initParams.currency;
        this._appliesTo = (0, util_1.camelArray)(initParams.applies_to);
        this._name = initParams.name;
        this._metadata = initParams.metadata;
        this._percentOff = initParams.percent_off;
        this._valid = initParams.valid;
    }
    set currency(value) {
        console.error('Do not set objects this way');
    }
    get currency() {
        return this._currency;
    }
    set appliesTo(value) {
        console.error('Do not set objects this way');
    }
    get appliesTo() {
        return this._appliesTo;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    get name() {
        return this._name;
    }
    set metadata(value) {
        console.error('Do not set objects this way');
    }
    get metadata() {
        return this._metadata;
    }
    set percentOff(value) {
        console.error('Do not set objects this way');
    }
    get percentOff() {
        return this._percentOff;
    }
    set valid(value) {
        console.error('Do not set objects this way');
    }
    get valid() {
        return this._valid;
    }
}
exports.default = Discount;
//# sourceMappingURL=discount.js.map